import { render, staticRenderFns } from "./new-visit.modal.vue?vue&type=template&id=661da37f&scoped=true"
import script from "./new-visit.modal.vue?vue&type=script&lang=js"
export * from "./new-visit.modal.vue?vue&type=script&lang=js"
import style0 from "./new-visit.modal.vue?vue&type=style&index=0&id=661da37f&prod&lang=scss&scoped=true"
import style1 from "./new-visit.modal.vue?vue&type=style&index=1&id=661da37f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661da37f",
  null
  
)

export default component.exports